<template>
  <div class="ec-line009" v-loading="loading">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <a :href="baseUrl">{{ this.shopName }}</a></el-breadcrumb-item
      >
      <el-breadcrumb-item>{{ $t('ec-line009.heading') }}</el-breadcrumb-item>
    </el-breadcrumb>
    <the-heading>{{ $t('ec-line009.heading') }}</the-heading>
    <div v-safe-html="noticeContent"></div>
    <div
      v-if="!!subscriptionErrorPayment.length || !!subscriptionErrorPaymentAndIsLumpsum.length"
      class="mx-4 my-5 lg:my-10 lg:mx-9 text-base font-normal"
    >
      <p class="whitespace-pre-line text-red-150">
        {{ $t('ec-line009.content.hasBatchError') }}
      </p>
      <div v-if="!!subscriptionErrorPayment.length">
        <div
          class="flex flex-wrap text-red-150 text-base font-normal"
          v-for="{ code, delivery_date, index } in subscriptionErrorPayment"
          :key="index"
        >
          <p class="mr-3">
            {{
              $t('ec-line009.content.deliverToFixePoint', {
                index,
                delivery_date: Utils.date.getDateString(delivery_date, Constants.FORMAT_DATE),
              })
            }}
          </p>
          <span class="text-blue-650 underline cursor-pointer" @click="toCpayPage(code)">{{
            $t('ec-line009.moveToDetail')
          }}</span>
        </div>
      </div>
      <div v-if="subscriptionErrorPaymentAndIsLumpsum.length">
        <div
          class="flex flex-wrap text-base font-normal"
          v-for="{ code, delivery_date, index } in subscriptionErrorPaymentAndIsLumpsum"
          :key="index"
        >
          <p class="mr-3 text-red-150">
            {{
              $t('ec-line009.content.deliverToFixePoint', {
                index,
                delivery_date: Utils.date.getDateString(delivery_date, Constants.FORMAT_DATE),
              })
            }}
          </p>
          <span class="whitespace-pre-line md:whitespace-normal">{{ $t('ec-line014.lumpsum.shopInfo.info') }}</span>
        </div>
        <div class="text-center text-base leading-normal">
          <p class="text-xl font-bold mt-2">{{ Utils.helper.formatPhoneNumber(shop.phone_number) }}</p>
          <p>{{ shop.business_hour }}</p>
        </div>
      </div>
    </div>

    <rank-member-information v-if="isVisibleRankMember && customer && customer.rank_use_flag" :data="customer" />
    <purchase-information
      v-if="mypagePurchaseOn && corporateFlag"
      :ref="Constants.PURCHASE_INFO_REF"
      :data="purchases"
      :total-items="purchasePagination.total_items"
    />
    <subscription-information
      v-if="mypageSubscriptionOn"
      :ref="Constants.SUBS_INFO_REF"
      :tab-subscription="tab"
      :data="subscription"
    />
    <purchase-information
      v-if="mypagePurchaseOn && !corporateFlag"
      :ref="Constants.PURCHASE_INFO_REF"
      :data="purchases"
      :total-items="purchasePagination.total_items"
    />
    <member-information v-if="mypageCustomerOn" :data="customer" :corporate-flag="corporateFlag"></member-information>
    <shipping-information v-if="mypageShippingOn" ref="shippingSection" :data="shipping"></shipping-information>
    <payment-information v-if="mypagePaymentOn" ref="paymentSection" :data="payment"></payment-information>
  </div>
</template>

<script>
import TheHeading from '@/components/my-page-partials/TheHeading.vue'
import MemberInformation from '@/components/ec-line009/MemberInformation.vue'
import ShippingInformation from '@/components/ec-line009/ShippingInformation.vue'
import PaymentInformation from '@/components/ec-line009/PaymentInformation.vue'
import RankMemberInformation from '@/components/ec-line009/RankMemberInformation.vue'
import SubscriptionInformation from '@/components/ec-line009/SubscriptionInformation.vue'
import PurchaseInformation from '@/components/ec-line009/PurchaseInformation.vue'
import {
  AddressService,
  MyPageService,
  AuthService,
  SubscriptionService,
  ShopService,
  HtmlService,
  OrderService,
} from '@/services'
import BreadcrumbMixin from '@/mixins/breadcrumb'
import { EC_LINE009, ERROR_PAYMENT_REF } from '@/constants'
import format from 'string-format'
import { ENV_KEY } from '@/constants/env'
import store from '@/store'
import { isVisibleRankMemberShopDetail } from '@/utils'
import amazonMixin from '@/mixins/amazonV2'
import { AMAZON } from '@/constants/amazon'

export default {
  components: {
    TheHeading,
    MemberInformation,
    SubscriptionInformation,
    ShippingInformation,
    PaymentInformation,
    RankMemberInformation,
    PurchaseInformation,
  },
  mixins: [BreadcrumbMixin, amazonMixin],
  data() {
    return {
      customer: {},
      shipping: {},
      payment: {
        payment_method: this.$t('common.paymentMethod.creditCard'),
        items: [],
      },
      subscription: [],
      purchases: [],
      loading: false,
      pagination: {},
      purchasePagination: {},
      formPagenation: {
        record_limit: 3,
        page: 1,
      },
      tab: EC_LINE009.TABS_TYPE.NORMAL,
      scrollToShippingSection: false,
      scrollToPaymentSection: false,
      mypageSubscriptionOn: false,
      mypagePurchaseOn: false,
      mypageCustomerOn: false,
      mypageShippingOn: false,
      mypagePaymentOn: false,
      isVisibleRankMember: false,
      noticeContent: '',
    }
  },
  beforeRouteEnter(_to, from, next) {
    if (from.name === 'EC_LINE011_NEW' || from.name === 'EC_LINE011_UPDATE' || from.name === 'EC_LINE027') {
      next((vm) => vm.setScrollToSection(1))
    } else if (from.name === 'EC_LINE012') {
      next((vm) => vm.setScrollToSection(2))
    } else {
      next((vm) => vm.setScrollToSection())
    }
  },
  computed: {
    user() {
      return this.$store.getters['auth/user']
    },
    subscriptionErrorPayment() {
      return this.subscription
        .filter((item) => item.code && !item.lump_sum_payment_flag)
        .map((sub) => ({ index: sub.index, delivery_date: sub.next_delivery_date, code: sub.code }))
        .sort((subA, subB) => subA.index - subB.index)
    },
    corporateFlag() {
      return this.$store.getters['auth/shop']?.corporate_flag
    },
    myPageShippingOnFlag() {
      return this.$store.getters['auth/shop']?.mypage_shipping_on
    },
    myPagePaymentOnFlag() {
      return this.$store.getters['auth/shop']?.mypage_payment_on
    },
    shop() {
      return this.$store.getters['auth/shop']
    },
    subscriptionErrorPaymentAndIsLumpsum() {
      return this.subscription
        .filter((item) => item.lump_sum_payment_flag && item.code)
        .map((sub) => ({ index: sub.index, delivery_date: sub.next_delivery_date, code: sub.code }))
        .sort((subA, subB) => subA.index - subB.index)
    },
  },
  async created() {
    await this.getVisibleRankMemberShopDetail()
    await this.fetchMe()
    await this.logoutAmazon()
    await this.fetchHtmlContent()
  },
  methods: {
    async getVisibleRankMemberShopDetail() {
      const shopID = store.getters['env/GET_KEY'](ENV_KEY.SHOP_ID)
      const { data } = await ShopService.getShopInfo(shopID)
      if (data) {
        this.isVisibleRankMember = isVisibleRankMemberShopDetail(data)
      }
    },
    async fetchEnable() {
      try {
        const { data } = await MyPageService.getMyPageEnableinfo({})
        if (data) {
          this.mypageSubscriptionOn = data.mypage_subscription_on
          this.mypageCustomerOn = data.mypage_customer_on
          this.mypageShippingOn = data.mypage_shipping_on
          this.mypagePaymentOn = data.mypage_payment_on
          this.mypagePurchaseOn = data.mypage_purchase_on
        }
      } catch (error) {
        this.handleError(error)
      }
    },
    async fetchData() {
      try {
        this.loading = true
        await Promise.all([this.fetchAddress(), this.fetchCard(), this.fetchSubscription(), this.fetchPurchases()])
        const headerHeight = 56

        if (this.scrollToShippingSection && this.myPageShippingOnFlag) {
          const offsetTop = this.$refs.shippingSection.$el.offsetTop
          window.scroll({ behavior: 'smooth', top: offsetTop - headerHeight })
        } else if (this.scrollToPaymentSection && this.myPagePaymentOnFlag) {
          const offsetTop = this.$refs.paymentSection.$el.offsetTop
          window.scroll({ behavior: 'smooth', top: offsetTop - headerHeight })
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.loading = false
      }
    },
    async fetchMe() {
      try {
        const { data } = await AuthService.me()
        this.customer = data
        this.fetchEnable()
        this.fetchData()
      } catch (error) {
        this.handleError(error)
        this.$router.push(this.$routePage.EC_LINE031)
      }
    },
    async fetchCard() {
      const { data } = await MyPageService.getCardList({ customer_id: this.customer.id })
      if (data && data.length) {
        this.payment.items = data.reverse()
        this.card_default =
          this.payment.items.find((i) => i.default_flag === '1')?.card_seq || this.payment.items?.[0].card_seq || null
        if (this.card_default) {
          this.customer.default_card_seq_num = this.card_default
        }
      }
    },
    async fetchAddress() {
      const { data } = await AddressService.getListAddress()
      if (data && data.length) {
        this.shipping = data.find((i) => i.is_default) || data[0]
      }
    },
    async fetchSubscription() {
      const subscriptionStatusList = Object.values(this.Constants.SUBSCRIPTION_STATUS).filter((item) => {
        return item !== this.Constants.SUBSCRIPTION_STATUS.CANCEL
      })
      const subscription_status = subscriptionStatusList.join(',')
      const params = {
        subscription_status,
        page: 1,
        record_limit: 100,
      }
      const { data } = await SubscriptionService.getSubscriptions(params)
      const { pagination, items } = data
      this.pagination = pagination

      this.subscription.push(
        ...items
          .filter((item) => item.subscription_status_id !== this.Constants.SUBSCRIPTION_STATUS.CANCEL)
          .map((item) => ({
            ...item,
            index: item.subscription_no,
            ref:
              ((item.is_payment_error_in_btc1 ||
                item.is_payment_error_in_btc6 ||
                item.is_payment_error_in_btc7 ||
                item.code) &&
                format(ERROR_PAYMENT_REF, { no: item.subscription_no })) ||
              '',
          }))
      )
    },
    async fetchPurchases() {
      const { data } = await OrderService.getOrderList(this.formPagenation)
      const { pagination, items } = data
      this.purchasePagination = pagination
      this.purchases = items
    },
    setScrollToSection(val) {
      if (val === 1) {
        this.scrollToShippingSection = true
        this.scrollToPaymentSection = false
      } else if (val === 2) {
        this.scrollToShippingSection = false
        this.scrollToPaymentSection = true
      } else {
        this.scrollToShippingSection = false
        this.scrollToPaymentSection = false
      }
    },
    async fetchHtmlContent() {
      const res = await HtmlService.getHtmlContent(this.Constants.SHOP_CONFIG.NOTICE_BOARD)
      this.noticeContent = res.data
    },
    toCpayPage(code) {
      window.open(`${this.$store.getters['env/GET_KEY'](ENV_KEY.BASE_URL)}/lpc/cpay?code=${code}`, '_blank')
    },
    logoutAmazon() {
      if (this.isLoginAmazon) {
        this.onAmazonLogout(AMAZON.ACCESS_TOKEN_015)
      }
    },
  },
  metaInfo() {
    return {
      title: this.$t('ec-line009.title'),
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.$t('ec-line009.description', { shop_name: this.shopName }),
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.$t('ec-line009.keyword', { shop_name: this.shopName }),
        },
      ],
    }
  },
}
</script>

<style lang="scss">
@import '@/assets/css/pages/ec-line009.scss';
</style>
